var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h2',[_vm._v("お知らせ一覧")]),_vm._l((_vm.notice_list),function(notice){return _c('div',{key:notice.id,on:{"click":function($event){return _vm.$router.push('/notice/' + notice.id)}}},[_c('h2',[_vm._v(_vm._s(_vm._f("omittedText")(notice.topic)))])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }